import React from 'react';
import { Eye, Trash2 } from 'react-feather';
import { Popup } from 'components/quashed';
import { IInvitation } from 'types';
import styles from './styles/InvitationDetails.module.scss';

const fields = [
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'relationship', label: 'Relationship' },
  { key: 'createdAt', label: 'Date added' },
  {
    key: 'processed',
    label: 'Status',
    render: (invitation: IInvitation, showStatus) => {
      return (
        showStatus && (
          <div
            key="processed"
            className={classnames(styles.field, styles.status)}
          >
            <span
              className={classnames(
                styles.dot,
                invitation?.processed && styles.active,
              )}
            />
            {invitation?.processed ? 'Active' : 'Pending'}
          </div>
        )
      );
    },
  },
];

const InvitationDetails = ({
  invitation,
  open,
  showConfirm,
  showStatus,
  closeDeleteConfirm,
  onClose,
  onDeleteInvitation,
  openDeleteConfirm,
  viewDashboard,
}) => {
  return (
    <Popup
      className={styles.modal}
      open={open}
      showCloseIcon={true}
      showNav={true}
      onClose={onClose}
    >
      {fields.map((f) =>
        f.render ? (
          f.render(invitation, showStatus)
        ) : (
          <div key={f.key} className={styles.field}>
            <div className={styles.label}>{f.label}</div>
            <div className={styles.value}>{invitation?.[f.key]}</div>
          </div>
        ),
      )}
      {showStatus ? (
        <div className={classnames(styles.button, styles.delete)}>
          <div className={styles.buttonWrap} onClick={openDeleteConfirm}>
            <Trash2 />
            Remove {invitation?.processed ? 'access' : 'pending invite'}
          </div>
          <div
            className={classnames(styles.confirm, showConfirm && styles.show)}
          >
            Are you sure?{' '}
            <b onClick={() => onDeleteInvitation(invitation)}>Yes</b> or{' '}
            <b onClick={closeDeleteConfirm}>No</b>
          </div>
        </div>
      ) : (
        <div className={styles.button}>
          <div className={styles.buttonWrap} onClick={viewDashboard}>
            <Eye />
            View dashboard
          </div>
        </div>
      )}
    </Popup>
  );
};

export default InvitationDetails;
